import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import Printd from 'printd'
import VueBarcode from 'vue-barcode';
import pdfMake from "pdfmake/build/pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import VueQRCodeComponent from 'vue-qrcode-component'


export default {
  name: 'lr-copy',
  components: {
    VueElementLoading,
    'barcode': VueBarcode,
    'qr-code':VueQRCodeComponent
  },
  props: ['selectedData'],
  data: function() {
    return {
      PrintAWBModal: false,
      memoData: JSON.parse(JSON.stringify(this.selectedData)),
      irnQR : null,
      title: '',
      cgstflag:false,
      igstflag:false,
      gstflag:false,
    }
  },
  computed: {},
  async mounted () {
    console.log("this.memoData",this.memoData);
    this.title = 'TAX INVOICE'
    if (this.memoData.irnresponse && this.memoData.irnresponse.signedQRCode) {
      this.irnQR = this.memoData.irnresponse.signedQRCode
      //for testing use-
      // this.irnQR = 'eyJhbGciOiJSUzI1NiIsImtpZCI6IkI4RDYzRUNCNThFQTVFNkY0QUFDM0Q1MjQ1NDNCMjI0NjY2OUIwRjgiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJ1TlkteTFqcVhtOUtyRDFTUlVPeUpHWnBzUGcifQ.eyJkYXRhIjoie1wiU2VsbGVyR3N0aW5cIjpcIjI3QUFJQ0E1ODc4UjFaTlwiLFwiQnV5ZXJHc3RpblwiOlwiMjdBQUdDQjM5MDRQMVpEXCIsXCJEb2NOb1wiOlwiQVNNQUhTRjIyMjMwNzE4XCIsXCJEb2NUeXBcIjpcIklOVlwiLFwiRG9jRHRcIjpcIjExLzEwLzIwMjJcIixcIlRvdEludlZhbFwiOjE4NzU4MDA1LFwiSXRlbUNudFwiOjIsXCJNYWluSHNuQ29kZVwiOlwiOTk4NTEzXCIsXCJJcm5cIjpcIjgzMDAzZDc2MWMwZTgxNjg5NTlmYzIxYzM1OTliZDZjYjRkMzdjNGRiOTQxOTFlNDFhZjFjZjA1MDVhOWEyMjFcIixcIklybkR0XCI6XCIyMDIyLTEwLTExIDEzOjQ4OjAwXCJ9IiwiaXNzIjoiTklDIn0.DxZ1l0Z_27TBH4hjQ9F4B63Qqzp2UCWahWIm4NesJiXfQ8FstnV7SU5mDvaOBoBTt7vZb3d8XX0flKl-oFb3JmH__UbAx9Bc0FGC6rTPd1brt4Xo2kifqfIfxBOO0HXHESVHA6aseTYYSZvR4LX_3Uooms5sLjt8CNJ29rFGGq8WRLSQIhbMqRfwH-GwYbZPScQVxWZ0XuIe5qeevycuS5GM4q3CFA_rLAp4mC3o77biaIC0mIeDIQZlQ-WI4focD3YQjw8sT-Iv6I9QU7ITJ1ssuwkIGDGSUjjrPCAKG5boAaQhqvg1o0qYPAubRbS1Q9O2lkYWsEqcnRyHsYCQew'
    }
    let cgst = parseInt(this.memoData.cgst)
    let sgst = parseInt(this.memoData.sgst)

    if(cgst && sgst){
      this.cgstflag = true
    }else if (this.memoData.igst){
      this.igstflag = true
    }else{
      this.gstflag = true
    }
  },
  methods: {
    closePrintAWBModal(){
       this.PrintAWBModal = false;
    },
    DownloadAWB(){
      const contentHtml = document.getElementById('printCashMemoData').innerHTML;
      var html = htmlToPdfmake(contentHtml);
      var docDefinition = {
       content: [
         html
       ],
       styles:{
         'with-margin':{
           marginLeft: 30 // apply a margin with the specific class is used
         }
       }
      };
      pdfMake.createPdf(docDefinition).download();
    },
    printAWBPage() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 1;
    border-top: 1px solid #c2cfd6;
}
           table {
               border-collapse: collapse;
               margin-left:10px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           header {
             font-size: 9px;
             color: #000;
             text-align: left;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          h3 {
          page-break-after: always;
          }
          }
          `
      d.print(document.getElementById('printCashMemoData'), cssText);
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FtcRadShipment/FTCMemoDepositSlip/FTCMemoDepositSlip.component.js